import { useEffect, useState } from "react";
import API from "../config/api.js";

export default function AccountSubscriptionsInvoicesModal({ idgateway, onClose }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const fd = new FormData();
        fd.append("idgateway", idgateway);
        const res  = await fetch(`${API.stripe}?listInvoices`, {
          method: "POST", credentials: "include", body: fd,
        });
        const data = await res.json();
        setInvoices(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("listInvoices error:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [idgateway]);

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      />
      <div className="modal fade show d-block" style={{ zIndex: 1050 }} role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Invoices</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              {loading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm" />
                </div>
              ) : invoices.length === 0 ? (
                <p className="text-muted mb-0">No invoices found.</p>
              ) : (
                invoices.map((inv, i) => (
                  <div key={i}>
                    <div className="row align-items-center my-2">
                      <div className="col-4 col-md-3">{inv.date}</div>
                      <div className="col-4 col-md-3 text-capitalize text-center">{inv.status}</div>
                      <div className="col-4 col-md-3 text-uppercase">
                        ${inv.amount} {inv.currency}
                      </div>
                      <div className="col-12 col-md-3 text-end">
                        <a
                          href={inv.invoice_url}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          Download
                        </a>
                      </div>
                    </div>
                    {i < invoices.length - 1 && <hr className="d-block d-sm-none" />}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}